import { parseStringValue } from "../parse-string-value.js";
export function stringField(opts) {
    return (value) => {
        const res = parseStringValue(value, opts);
        if (!res.isValid || !res.value)
            return res;
        if (opts.minLength && res.value.length < opts.minLength.value) {
            return {
                isValid: false,
                error: opts.minLength.message,
            };
        }
        if (opts.maxLength && res.value.length > opts.maxLength.value) {
            return {
                isValid: false,
                error: opts.maxLength.message,
            };
        }
        if (opts.regex && !opts.regex.value.test(res.value)) {
            return {
                isValid: false,
                error: opts.regex.message,
            };
        }
        return {
            isValid: true,
            value: res.value,
        };
    };
}
